import(/* webpackMode: "eager" */ "/my-first-project/app/global-error.tsx")